function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.895 62.334l-5.419-5.2m-3.613-3.467l-.903-.867",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.172 31.19V6.053C31.172 3.824 33.035 2 35.31 2c2.276 0 4.138 1.824 4.138 4.054V31.19m8.276-17.027c0-2.372 2.09-4.277 4.573-4.034 2.151.203 3.703 2.149 3.703 4.257v28.37c0 7.924-2.986 12.255-5.606 14.642M38.434 62c-4.655 0-9.124-1.804-12.413-5.047l-4.164-4.08-4.164-4.08-8.327-8.158A4.556 4.556 0 018 37.392c0-2.534 2.09-4.581 4.676-4.581a4.75 4.75 0 013.31 1.338l3.997 3.915c1.084 1.063 2.914.294 2.914-1.224V9.52c0-2.128 1.551-4.054 3.703-4.256 2.483-.244 4.572 1.662 4.572 4.033m8.276 0c0-2.23 1.862-4.054 4.138-4.054s4.138 1.825 4.138 4.054V31.19M28.5 42.755c4.298.892 7.655 3.891 8.247 7.873",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M64 38c0 14.43-3.488 20.86-9.302 26.35-4.651 4.392-12.002 5.722-15.698 5.647M64 28v5M46 60c-.672.411-1.345.74-2 1",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

function SvgWithheld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/withheld.svg";
export { SvgWithheld as ReactComponent };